// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC0VLm7pKuI7kOiST1Ve1kuyHBEUmcbCsU",
  authDomain: "umadesign-e9ca3.firebaseapp.com",
  projectId: "umadesign-e9ca3",
  storageBucket: "umadesign-e9ca3.appspot.com",
  messagingSenderId: "70806139957",
  appId: "1:70806139957:web:de5480041e173d7a1cad7c",
  measurementId: "G-DFP293MR7C",
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db, storage, auth };